import { AccordionItem } from '@mm/components';
import {
  AccordionAPI,
  Props as AccordionItemProps,
} from '@mm/components/src/AccordionItem/AccordionItem';
import classNames from 'classnames';
import React, { ReactNode, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import {
  BaseIntegrationEmptyState,
  BaseIntegrationEmptyStateProps,
} from './BaseIntegrationEmptyState';

export type CrmIntegrationsTypes =
  | 'sendlane'
  | 'klaviyo'
  | 'mailchimp'
  | 'zapier'
  | 'default'
  | 'google_spreadsheet'
  | 'gohighlevel'
  | 'salesforce'
  | 'facebook_ads_audience'
  | 'google_ads_audience'
  | 'shopify';

export const BaseIntegration = ({
  accordionRef,
  children,
  titleComponent,
  integrationType,
  showEmptyState,
  emptyStateConfig,
  onToggle,
  accorditionItemProps,
  openOnMount: openOnMountProp,
  className,
}: {
  children: ReactNode;
  titleComponent: ReactNode;
  integrationType?: CrmIntegrationsTypes | string;
  showEmptyState?: boolean;
  emptyStateConfig?: BaseIntegrationEmptyStateProps;
  onToggle?: () => void;
  accorditionItemProps?: Partial<AccordionItemProps>;
  accordionRef?: React.RefObject<AccordionAPI>;
  openOnMount?: boolean;
  className?: string;
}) => {
  const location = useLocation<{ options?: CrmIntegrationsTypes }>();
  const locationOptionsParam = location.state?.options;

  const openOnMount = useMemo(() => {
    if (openOnMountProp) {
      return openOnMountProp;
    }

    if (integrationType && locationOptionsParam) {
      return locationOptionsParam === integrationType;
    }
    return false;
  }, [integrationType, location?.state?.options, openOnMountProp]);

  return (
    <div className={classNames('integrations-component', className)}>
      <AccordionItem
        ref={accordionRef}
        className="integrations-item"
        caretStyleIcon
        closeOnOutsideClick={false}
        titleComponent={titleComponent}
        onToggle={onToggle}
        openOnMount={openOnMount}
        {...accorditionItemProps}
      >
        {showEmptyState && emptyStateConfig ? (
          <BaseIntegrationEmptyState {...emptyStateConfig} />
        ) : (
          children
        )}
      </AccordionItem>
    </div>
  );
};
